/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 셀병합 툴을 정의한다.
 *
 * @file /src/rootin/blocks/table/tools/Split.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 9. 7.
 */
import { Tool } from '@rootin/base/Tool';
import { Block } from '@rootin/base/Block';
import { Element } from '@rootin/base/Element';
import { Language, LanguageText } from '@utils/Language';

export class Split extends Tool {
    /**
     * 툴타입
     */
    static type: string = 'split';

    /**
     * 툴그룹
     */
    static group: string = 'table-split';

    /**
     * 툴아이콘
     */
    icon2: string =
        '<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /><path fill="currentColor" d="M3.643 8.356Q3.5 8.213 3.5 8V5.116q0-.667.475-1.141t1.14-.475H8q.213 0 .356.144t.144.357t-.144.356T8 4.5H5.116q-.27 0-.443.173t-.173.443V8q0 .213-.144.356t-.357.144t-.356-.144m16 0Q19.5 8.213 19.5 8V5.116q0-.27-.173-.443t-.442-.173H16q-.213 0-.356-.144t-.144-.357t.144-.356T16 3.5h2.885q.666 0 1.14.475t.475 1.14V8q0 .213-.144.356t-.357.144t-.356-.144m-3.172 6.423l-2.194-2.214q-.242-.242-.242-.565t.242-.566l2.194-2.213q.146-.146.347-.146t.367.15t.165.357t-.165.352L15.614 11.5H21q.213 0 .356.144t.144.357t-.144.356T21 12.5h-5.386l1.57 1.566q.147.145.156.346t-.156.367q-.15.146-.359.146t-.354-.146m-9.64 0q-.156-.146-.159-.357q-.003-.21.144-.357l1.57-1.565H3q-.213 0-.356-.144t-.144-.357t.144-.356T3 11.5h5.387L6.816 9.935q-.147-.147-.141-.355q.006-.207.146-.359q.166-.146.364-.155t.344.155l2.194 2.214q.243.242.243.565t-.243.566l-2.194 2.213q-.148.146-.345.146t-.353-.146M5.116 20.5q-.667 0-1.141-.475t-.475-1.14V16q0-.213.144-.356t.357-.144t.356.144T4.5 16v2.885q0 .269.173.442t.443.173H8q.213 0 .356.144t.144.357t-.144.356T8 20.5zM16 20.5q-.213 0-.356-.144t-.144-.357t.144-.356T16 19.5h2.885q.269 0 .442-.173t.173-.442V16q0-.213.144-.356t.357-.144t.356.144t.143.356v2.885q0 .666-.475 1.14t-1.14.475z" /></svg>';

    icon: string =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-table-centerline-dashed-vertical-icon lucide-table-centerline-dashed-vertical"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M3 12h6"/><path d="M15 12h6"/><path d="M12 3v2"/><path d="M12 8v2"/><path d="M12 14v2"/><path d="M12 19v2"/><path d="M15 12l3-3"/><path d="M15 12l3 3"/><path d="M9 12l-3 3"/><path d="M9 12l-3-3"/></svg>';

    /**
     * 툴팁
     */
    text: LanguageText = Language.get('rootin.blocks.table.tools.split');

    /**
     * 툴 클릭시 실행할 핸들러를 정의한다.
     */
    async handler(): Promise<void> {}

    /**
     * 툴의 표시여부 조건을 설정한다.
     * @todo 커서가 편집 가능한 유닛 안이거나 다중 유닛이 선택돼 있을 때만 노출할지 고민한다.
     *
     * @param block - 커서가 위치한 블록
     * @param element - 커서가 위치한 편집유닛
     * @returns 표시여부
     */
    visible(block: Block | null, element: Element | null): boolean {
        return block.getParents('table') !== null;
    }

    /**
     * 툴이 활성여부 조건을 설정한다.
     *
     * @returns 활성여부
     */
    active(): boolean {
        return false;
    }
}
